// modules/website/components/ServicesComponent.tsx

import React from 'react';
import { FeaturesData } from '@/types';

interface Props {
  data: FeaturesData;
  settings: any;
}

export const ServicesComponent: React.FC<Props> = ({ data, settings }) => {
  return (
    <div 
      className="py-20 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
        color: settings.textColor || '#000000',
      }}
    >
      <div className="max-w-7xl mx-auto">
        {data.title && (
          <h2 className="text-4xl font-bold text-center mb-4">
            {data.title}
          </h2>
        )}
        {data.subtitle && (
          <p className="text-xl text-center text-gray-600 mb-12">
            {data.subtitle}
          </p>
        )}
        
        <div className={`grid gap-8 ${
          data.columns === 1 ? 'grid-cols-1' :
          data.columns === 2 ? 'grid-cols-1 md:grid-cols-2' :
          data.columns === 3 ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' :
          'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
        }`}>
          {(data.features || (data as any).services || []).map((feature: any, index: number) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-100"
            >
              <div className="text-5xl mb-4">{feature.icon}</div>
              <h3 className="text-2xl font-bold mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
